import { useMutation } from '@tanstack/react-query';
import { getProgram } from '../../../core/queries/course';

function useFetchProgram() {
  const { data, isError, error, isSuccess, isPending, mutate, mutateAsync } = useMutation({
    mutationKey: ['fetch-program'],
    mutationFn: (data: any) => getProgram(data.courseId, data.programId),
    retry: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
    mutateAsync
  };
}

export { useFetchProgram };
